// extracted by mini-css-extract-plugin
export default {"wrapper":"About_wrapper__J2UT2"};